import Vue from 'vue';
import Loader from '@/components/misc/loader.vue';
import PopupWrap from '@/components/misc/PopupWrap.vue';
import MainButton from '@/components/@core/MainButton/index.vue';
import MainCheckbox from '@/components/@core/MainCheckbox/index.vue';
import autocomplete from '@/components/autocomplete/index.vue';
import SmallLoader from '@/components/misc/SmallLoader.vue';
import Breadcrumbs from '@/components/@general/Breadcrumbs/index.vue';
import MainSidebar from '@/components/@general/MainSidebar/index.vue';

Vue.component('SmallLoader', SmallLoader);
Vue.component('Loader', Loader);
Vue.component('Breadcrumbs', Breadcrumbs);
Vue.component('PopupWrap', PopupWrap);
Vue.component('MainButton', MainButton);
Vue.component('MainCheckbox', MainCheckbox);
Vue.component('MainSidebar', MainSidebar);
Vue.component('autocomplete', autocomplete);
Vue.component('v-pagination', window['vue-plain-pagination']);
